import { render } from "./qxc-q2.vue?vue&type=template&id=6a79dc26&scoped=true"
import script from "./qxc-q2.vue?vue&type=script&lang=js"
export * from "./qxc-q2.vue?vue&type=script&lang=js"

import "./qxc-q2.vue?vue&type=style&index=0&id=6a79dc26&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a79dc26"]])

export default __exports__